import genericRule from '../../namespace/relation/doingGet_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'savedFilter'
};
